<div class="clients-container">
    <strong>Nos Clients</strong>
    <div class = "list-clients">
        <img src = "../../../assets/images/icons/Arval-logo-C5F50765B7-seeklogo.com_-1 1.png" style="height: 4vw;">
        <img src = "../../../assets/images/icons/Essilor-Logo-2012-e1696597672860-1024x382 1.png" style="height: 4vw;">
        <img src = "../../../assets/images/icons/Microsoft_logo_2012.svg-1024x218 1.png" style="height: 2.5vw; margin-top: 1vw;">
        <img src = "../../../assets/images/icons/logo-1024x449 1.png" style="height: 3.5vw; margin-top: 0.5vw;">
        <img src = "../../../assets/images/icons/Logo_JobTeaser-1 1.png" style="height: 4vw; width: 14vw;">
        <img src = "../../../assets/images/icons/Chanel_logo_complet-1-1024x656 1.png" style="width: 7.5vw;">
    </div>
</div>

